module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAeCAYAAAARgF8NAAAABGdBTUEAALGPC/xhBQAAAFVJREFUKBVjNFn90fMvA+Mshv//ZRiQASPjE2aG/2mMhqs/PcaQhCkEKmLCKQlSBDSVCaYYFz2qABIyo+EwGg7IeYSJAZi9kAVQ2KCsB8qgWBVBMy8A9dUYoXJ4iRMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huiyiTitle.png
// module id = XIpQ
// module chunks = 3